import React from "react";

const Marquee = ({ items = [], speed = 38, accent = false }) => {
  const list = [...items, ...items];
  return (
    <div
      className={`overflow-hidden border-y-2 border-[var(--ink)] ${
        accent ? "bg-[var(--red)] text-[var(--pink-soft)]" : "bg-[var(--paper)] text-[var(--ink)]"
      }`}
    >
      <div
        className="marquee-track flex whitespace-nowrap py-3"
        style={{ animationDuration: `${speed}s` }}
      >
        {list.map((it, i) => (
          <span
            key={i}
            className="font-masthead text-2xl md:text-3xl tracking-[0.18em] mx-8 inline-flex items-center gap-8"
          >
            {it}
            <span className="opacity-60">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
